export default "__VITE_ASSET__DqQen9Ph__"